/**
 * createSettingsPanelController — Settings stub: volume + keybinds entry (SPY-213).
 */

function escapeText(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function keybindRowHtml(rows) {
  return (rows || [])
    .map(
      (row) =>
        `<li data-action="${escapeText(row.action)}">` +
        `<span class="settings-keybind-action">${escapeText(row.action)}</span>` +
        `<kbd class="settings-keybind-key">${escapeText(row.key)}</kbd>` +
        `</li>`
    )
    .join('');
}

export function createSettingsPanelController({
  rootEl,
  masterVolumeEl,
  sfxVolumeEl,
  keybindsListEl,
  settings,
  listKeybinds
} = {}) {
  let open = false;
  let activeEntry = 'volume';

  function syncVolumeUi() {
    const snap = settings?.get?.() || {};
    if (masterVolumeEl) masterVolumeEl.value = String(snap.masterVolume ?? 1);
    if (sfxVolumeEl) sfxVolumeEl.value = String(snap.sfxVolume ?? 1);
  }

  function syncKeybindsUi() {
    if (!keybindsListEl) return;
    const rows = typeof listKeybinds === 'function' ? listKeybinds() : [];
    keybindsListEl.innerHTML = keybindRowHtml(rows);
  }

  function render() {
    syncVolumeUi();
    syncKeybindsUi();
    if (rootEl) {
      if (rootEl.dataset) rootEl.dataset.activeEntry = activeEntry;
      if (typeof rootEl.setAttribute === 'function') {
        rootEl.setAttribute('aria-hidden', open ? 'false' : 'true');
      }
    }
  }

  function show(visible) {
    open = !!visible;
    if (rootEl) rootEl.hidden = !open;
    render();
    return open;
  }

  function bindVolume(el, channel) {
    if (!el || typeof el.addEventListener !== 'function') return;
    el.addEventListener('input', (ev) => {
      const raw = ev?.target?.value;
      settings?.setVolume?.(channel, Number(raw));
      syncVolumeUi();
    });
  }

  bindVolume(masterVolumeEl, 'master');
  bindVolume(sfxVolumeEl, 'sfx');

  return {
    open: () => show(true),
    close: () => show(false),
    isOpen: () => open,
    getActiveEntry: () => activeEntry,
    setActiveEntry(id) {
      if (id === 'volume' || id === 'keybinds') activeEntry = id;
      render();
      return activeEntry;
    },
    refresh: render,
    getSettings: () => settings?.get?.() || null
  };
}
